import {AfterViewChecked, Directive, ElementRef, Input, OnInit} from '@angular/core';
import {NgModel} from '@angular/forms';
import {isNullOrUndefined} from 'util';

@Directive({
  selector: '[appSelectPlaceholder]'
})
export class SelectPlaceholderDirective implements AfterViewChecked, OnInit {
  @Input()
  appSelectPlaceholder: string;

  private element: any;
  private placeholderOption: HTMLOptionElement;

  constructor(element: ElementRef, private ngModel: NgModel) {
    this.element = element.nativeElement;
  }

  ngOnInit(): void {
    this.placeholderOption = this.createPlaceholderOption();
    this.element.add(this.placeholderOption);
  }

  ngAfterViewChecked(): void {
    this.element.style.color = isNullOrUndefined(this.ngModel.model) ? Color.Sky : Color.Black;
    this.placeholderOption.selected = !!isNullOrUndefined(this.ngModel.model);
  }

  private createPlaceholderOption(): HTMLOptionElement {
    const option = new Option(this.appSelectPlaceholder, this.appSelectPlaceholder, true, true);
    option.hidden = true;
    option.disabled = true;

    return option;
  }
}

enum Color {
  Sky = '#96a0b8',
  Black = '#000'
}
